<template>
  <div class="chat-tools-display">
    <!-- Tool Suggestions -->
    <ToolsSuggestionsDisplay
      v-if="hasSuggestions"
      :tools="toolSuggestions"
      :headerText="suggestionsHeaderText"
      @select="handleToolSelect"
    />

    <!-- Next Steps -->
    <NextStepsDisplay
      v-if="hasSteps"
      :steps="nextSteps"
      :headerText="stepsHeaderText"
      @select="handlePromptSelect"
    />
  </div>
</template>

<script>
import ToolsSuggestionsDisplay from './ToolsSuggestionsDisplay.vue';
import NextStepsDisplay from './NextStepsDisplay.vue';

export default {
  name: 'ChatToolsDisplay',
  components: {
    ToolsSuggestionsDisplay,
    NextStepsDisplay,
  },
  props: {
    toolSuggestions: {
      type: Array,
      default: () => [],
      // Array of full tool objects from suggest_tools tool_result
      // Format: { id, name, description, score, explanation, use_case, location, url }
    },
    nextSteps: {
      type: Array,
      default: () => [],
      // Array of step strings
    },
    suggestionsHeaderText: {
      type: String,
      default: 'Here are some tools that might help:',
    },
    stepsHeaderText: {
      type: String,
      default: 'Next steps:',
    },
  },
  computed: {
    hasSuggestions() {
      return this.toolSuggestions && this.toolSuggestions.length > 0;
    },
    hasSteps() {
      return this.nextSteps && this.nextSteps.length > 0;
    },
  },
  methods: {
    handleToolSelect(tool) {
      this.$emit('tool-select', tool);
    },
    handlePromptSelect(step) {
      this.$emit('prompt-select', step);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-tools-display {
  margin-top: 8px;
}
</style>
